import { QueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { isAxiosError } from 'axios';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 30,
      staleTime: 1000 * 60 * 2,
      retry: false,
      refetchOnWindowFocus: false,
      onError: (error) => {
        if (isAxiosError(error)) {
          message.error(error.response?.data?.message ?? error.message);
        }
      },
    },
  },
});
